<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="senders"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of a sender type ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-senderType',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                senders: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getSenderTypes();
        },
        methods: {
            getSenderTypes:function(){
                axios.get('/api/selectable-sender-types')
                .then(function(response){
                    console.log(response);
                    var senders = [];
                    response.data.forEach(function(sender){
                        senders.push({ text: sender.name, value: sender.sender });
                    });
                    this.senders = senders;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
